import type { TeamCapacitySummary } from '../hooks/useTeamCapacities';
import type { CalendarTeam } from './CalendarView';
import { ResourceUtilizationBar } from './ResourceUtilizationBar';

interface MapTeamUtilizationPanelProps {
  teams: CalendarTeam[];
  summariesByTeam: Map<string, TeamCapacitySummary> | undefined;
}

export function MapTeamUtilizationPanel({ teams, summariesByTeam }: MapTeamUtilizationPanelProps) {
  if (!summariesByTeam || teams.length === 0 || summariesByTeam.size === 0) return null;

  return (
    <div className="absolute top-3 left-3 bg-white dark:bg-zinc-900 border border-border rounded-lg p-3 shadow-md z-10 max-w-[260px]">
      <p className="text-xs font-medium text-foreground mb-2">Team utilisation</p>
      <div className="space-y-2">
        {teams.map((team) => {
          const s = summariesByTeam.get(team.id);
          if (!s) return null;
          return (
            <div key={team.id} className="space-y-0.5">
              <div className="text-xs text-foreground truncate">{team.name}</div>
              <ResourceUtilizationBar
                utilizationPercent={s.averageUtilization}
                bookedHours={s.totalBookedHours}
                availableHours={s.totalAvailableHours}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
